import { COLORS } from 'components/containers/Theme/defaults';
import { IconName } from 'components/core/Icon/Icon';

export const CDN_URL = 'https://iconslib.rapyd.net/assets/hosted-pages';
export const CDN_IMAGES_URL = `${CDN_URL}/images`;

export const BLACK = COLORS.BLACKS[1];
export const WHITE = COLORS.WHITES[1];
export const MINIMUM_CONTRAST = 3;

export const ERROR_CODE = 'ERR';
export const CLOSE_CODE = 'CLO';
export const ACT_CODE = 'ACT';
export const NEW_CODE = 'NEW';
export const CAN_CODE = 'CAN';
export const DON_CODE = 'DON';
export const DECLINED_STATUS = 'DEC';
export const AFTER_PAYMENT_CODE = 'AFT';
export const IN_PROGRESS_STATUS = 'INP';
export const SUCCESS_CODE = 'SUCCESS';
export const PAYMENT_ERROR_STATUSES = [CAN_CODE, ERROR_CODE, DECLINED_STATUS, ''];

export const TABS_IMAGES = {
  card: `${CDN_IMAGES_URL}/card-v2.svg`,
  card_redirect: `${CDN_IMAGES_URL}/card-v2.svg`,
  cash: `${CDN_IMAGES_URL}/cash-v2.svg`,
  ewallet: `${CDN_IMAGES_URL}/ewallet-v2.svg`,
  bank: `${CDN_IMAGES_URL}/bank-v2.svg`,
  bank_transfer: `${CDN_IMAGES_URL}/bank-v2.svg`,
  bank_redirect: `${CDN_IMAGES_URL}/bank-v2.svg`
};

export const CATEGORY_ICON_NAMES = {
  card: IconName.CREDIT_CARD,
  card_redirect: IconName.CREDIT_CARD,
  cash: IconName.CASH,
  ewallet: IconName.WALLET,
  bank: IconName.BANK,
  bank_transfer: IconName.BANK,
  bank_redirect: IconName.BANK
};

export const EN_US = 'en-US';
const ES_MX = 'es-MX';
const ZH_TW = 'zh-TW';
const ZH_CN = 'zh-CN';
const KO_KR = 'ko-KR';
const PT_BR = 'pt-BR';
const ID_ID = 'id-ID';
const TL_PH = 'tl-PH';
const TH_TH = 'th-TH';
const DE_DE = 'de-DE';
const IS_IS = 'is-IS';
const NL_NL = 'nl-NL';
const FR_FR = 'fr-FR';
const JA_JP = 'ja-JP';
const HI_IN = 'hi-IN';
const VI_VN = 'vi-VN';
const MS_MY = 'ms-MY';
const RU_RU = 'ru-RU';
const UK_UA = 'uk-UA';
const EL_GR = 'el-GR';
const TR_TR = 'tr-TR';
const IT_IT = 'it-IT';
const LT_LT = 'lt-LT';
const ET_ET = 'et-ET';
const SK_SK = 'sk-SK';
const SL_SL = 'sl-SL';
const DK_DK = 'dk-DK';
const HE_IL = 'he-IL';
const SV_SV = 'sv-SV';
const CS_CS = 'cs-CS';
const LV_LV = 'lv-LV';
const MT_MT = 'mt-MT';
const NO_NO = 'no-NO';

const EMEA = 'EMEA';
const AMERICAS = 'AMERICAS';
const APAC = 'APAC';

export const REGIONS = { EMEA, AMERICAS, APAC };

export const LANGS = {
  [EN_US]: { lang: 'English', serverLang: 'en', friendlyName: '' },
  [ES_MX]: { lang: 'Español', serverLang: 'es', friendlyName: 'Spanish' },
  [ZH_TW]: { lang: '繁体中文', serverLang: 'zh-tw', friendlyName: 'Traditional Chinese' },
  [ZH_CN]: { lang: '简体中文', serverLang: 'zh-cn', friendlyName: 'Simplified Chinese' },
  [KO_KR]: { lang: '한국어', serverLang: 'ko', friendlyName: 'Korean' },
  [PT_BR]: { lang: 'Português', serverLang: 'pt', friendlyName: 'Portuguese' },
  [ID_ID]: { lang: 'Bahasa Indonesia', serverLang: 'id', friendlyName: 'Indonesian' },
  [TL_PH]: { lang: 'Tagalog', serverLang: 'tl', friendlyName: 'Philippine Tagalog' },
  [TH_TH]: { lang: 'ไทย', serverLang: 'th', friendlyName: 'Thai' },
  [DE_DE]: { lang: 'Deutsch', serverLang: 'de', friendlyName: 'German' },
  [IS_IS]: { lang: 'Íslenska', serverLang: 'is', friendlyName: 'Icelandic' },
  [NL_NL]: { lang: 'Nederlands', serverLang: 'nl', friendlyName: 'Dutch' },
  [FR_FR]: { lang: 'Français', serverLang: 'fr', friendlyName: 'French' },
  [JA_JP]: { lang: '日本語', serverLang: 'ja', friendlyName: 'Japanese' },
  [HI_IN]: { lang: 'हिन्दी', serverLang: 'hi', friendlyName: 'Hindi' },
  [VI_VN]: { lang: 'Tiếng Việt', serverLang: 'vi', friendlyName: 'Vietnamese' },
  [MS_MY]: { lang: 'Bahasa Malayu, بهاس ملايو', serverLang: 'ms', friendlyName: 'Malay' },
  [RU_RU]: { lang: 'Русский', serverLang: 'ru', friendlyName: 'Russian' },
  [UK_UA]: { lang: 'Українська', serverLang: 'uk', friendlyName: 'Ukrainian' },
  [EL_GR]: { lang: 'ελληνικά', serverLang: 'el', friendlyName: 'Greek' },
  [TR_TR]: { lang: 'Türkçe', serverLang: 'tr', friendlyName: 'Turkish' },
  [IT_IT]: { lang: 'Italiano', serverLang: 'it', friendlyName: 'Italian' },
  [LT_LT]: { lang: 'Lietuvių', serverLang: 'lt', friendlyName: 'Lithuanian' },
  [ET_ET]: { lang: 'Eesti keel', serverLang: 'et', friendlyName: 'Estonian' },
  [SK_SK]: { lang: 'Slovenčina', serverLang: 'sk', friendlyName: 'Slovak' },
  [SL_SL]: { lang: 'Slovenščina', serverLang: 'sl', friendlyName: 'Slovene' },
  [DK_DK]: { lang: 'Dansk', serverLang: 'dk', friendlyName: 'Danish' },
  [HE_IL]: { lang: 'עברית', serverLang: 'he', friendlyName: 'Hebrew' },
  [SV_SV]: { lang: 'Svenskt', serverLang: 'sw', friendlyName: 'Swedish' },
  [CS_CS]: { lang: 'Čeština', serverLang: 'cz', friendlyName: 'Czech' },
  [LV_LV]: { lang: 'Latviski', serverLang: 'lv', friendlyName: 'Latvian' },
  [MT_MT]: { lang: 'Malti', serverLang: 'mt', friendlyName: 'Maltese' },
  [NO_NO]: { lang: 'Norsk', serverLang: 'no', friendlyName: 'Norwegian' }
};

export const REGION_LANGS_MAPPER = {
  [EMEA]: [
    EN_US,
    ES_MX,
    FR_FR,
    DE_DE,
    IS_IS,
    PT_BR,
    NL_NL,
    IT_IT,
    RU_RU,
    UK_UA,
    TR_TR,
    EL_GR,
    LT_LT,
    ET_ET,
    SK_SK,
    SL_SL,
    DK_DK,
    HE_IL,
    SV_SV,
    CS_CS,
    LV_LV,
    MT_MT,
    NO_NO
  ],
  [AMERICAS]: [EN_US, ES_MX, PT_BR, ZH_CN, ZH_TW],
  [APAC]: [EN_US, ZH_CN, ZH_TW, KO_KR, JA_JP, TH_TH, HI_IN, VI_VN, ID_ID, MS_MY, TL_PH]
};

// Please note: regexes with global flag or sticky flat (g / y)
// can cause the regex to start the next test from the lastIndex.
// We should be careful with that.
// Please construct new regex instance whenever possible
// and use this consts just to save the template that returns.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/test
export const REGEXES = {
  identification_type:
    '(work_permit|international_passport|identification_id|social_security|residence_permit|company_registered_number|driver\'s_license)',
  identification_value: '^([a-zA-Z0-9]){1,30}$',
  dropdown: /^(\^)?(\()?([-_\s'\p{N}]|\p{L})*(\|(([-_\s'\p{N}]|\p{L})+))*(\))?(\$)?$/giu,
  cvv: /^[0-9]{3,4}$/,
  expiration: /(0[1-9]|1[012])\/[\d]{2}/,
  LIMIT_DIGITS_AS_NUMERIC_QUALIFIER_REGEX: [/^\^\[0-9\]\{\d+\}\$$/],
  LIMIT_DIGITS_AS_NUMERIC_QUALIFIER_REGEX_EXTRACTOR: /(?:\{)(\d+)(?:\}\$)/,
  NOT_IBAN_REGEX: /[^A-Z0-9]/g,
  LIMIT_DIGITS_AS_BRACKETS_REGEX: [/^\^(\[0-9\])+\$$/, /^\^\((\[0-9\])+\)\$$/],
  LIMIT_DIGITS_AS_BRACKETS_REGEX_EXTRACTOR: /\[0-9\]/g,
  LIMIT_DIGITS_AS_MONTH_STRING: ['^(0[1-9]|10|11|12)$'],
  LIMIT_DIGITS_AS_YEAR_STRING: ['^([2][0-9][0-9][0-9])$'],
  LIMIT_DIGITS_AS_NINE_RANGE_STRING: ['^([0-9]){9,9}$', '^(\\d){9,9}$'],
  TRANSFER_FUNDS_AMOUNT: /^\d+(.\d+)?$/,
  PIN_NUMBER: /^\d{4,}$/,
  SPECIAL_CHARACTERS: /[/`!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/,
  TASCOM_TRANSFER_REASON_UNALLOWED_CHARACTERS: /[^a-zA-Z0-9=\-,;.: ]/,
  RAP_CREATE_PAYMENT_CARD_NETWORK_ERROR_CODES: /^.*\[[a-zA-Z0-9]{2,}\]$/,
  RAP_CREATE_PAYMENT_CARD_NETWORK_ERROR_CODES_EXTRACTOR: /\[(.*?)\]$/,
  JAVASCRIPT_INLINE_EXPRESSION: /^(.*)javascript:(.*)$/,
  EMAIL:
    /^[a-zA-Z\d.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?(?:\.[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?)*$/,
  REGEX_INCLUDES_PLUS_SIGN_IN_THE_BEGINNING: /^\^\+|^\^\[\+]/,
  UPPERCASE_LETTER: /[A-Z]/,
  LOWERCASE_LETTER: /[a-z]/,
  DIGIT: /\d/,
  SYMBOL: /[^A-Za-z\d]/,
  EMPTY_REGEX: '',
  DATE: '^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/(19|20)[0-9][0-9]$', // Format of dd/mm/yyyy
  COUNTRY_CODE: '^[A-Z]{2}$', // Two-letter ISO 3166-1 ALPHA-2 code
  GENDER: '(male|female|other|not_applicable)'
};

export const TERMS_AND_CONDITIONS = 'terms & conditions';
export const YES_NO_OPTIONS = {
  YES: 'Yes',
  NO: 'No'
};
export const YES_NO_BUTTON_GROUP_OPTIONS = [
  {
    name: 'yes',
    label: 'yes',
    value: YES_NO_OPTIONS.YES
  },
  {
    name: 'no',
    label: 'no',
    value: YES_NO_OPTIONS.NO
  }
];

export const HOSTED_PAGE_TYPES = {
  checkout: 'checkout',
  beneficiaryTokenization: 'beneficiary_tokenization',
  cardTokenization: 'card_tokenization',
  cardIssuing: 'card_issuing',
  cardIssuingActivate: 'card_issuing_activate',
  cardIssuingResetPIN: 'card_issuing_pin',
  cardIssuingSetKba: 'card_issuing_kba',
  idv: 'idv',
  subscription: 'subscription',
  otp: 'otp',
  reusable_link: 'reusable_link',
  video: 'video',
  customerTokenization: 'customer_tokenization',
  payoutTracker: 'payout_tracker',
  demo: 'demo'
};

export const HOSTED_PAGE_TITLE = {
  [HOSTED_PAGE_TYPES.checkout]: 'Checkout',
  [HOSTED_PAGE_TYPES.subscription]: 'Subscription',
  [HOSTED_PAGE_TYPES.beneficiaryTokenization]: 'Beneficiary Account Details',
  [HOSTED_PAGE_TYPES.cardTokenization]: 'Save Card Details',
  [HOSTED_PAGE_TYPES.cardIssuing]: 'Issued Card Details',
  [HOSTED_PAGE_TYPES.cardIssuingActivate]: 'Card Activation',
  [HOSTED_PAGE_TYPES.cardIssuingResetPIN]: 'PIN Management',
  [HOSTED_PAGE_TYPES.cardIssuingSetKba]: 'Set KBA Password',
  [HOSTED_PAGE_TYPES.idv]: 'Identity Verification',
  [HOSTED_PAGE_TYPES.customerTokenization]: 'Customer Details',
  [HOSTED_PAGE_TYPES.reusable_link]: 'Payment Link',
  [HOSTED_PAGE_TYPES.payoutTracker]: 'Payout Tracker',
  [HOSTED_PAGE_TYPES.otp]: 'OTP'
};

export const HOSTED_PAGE_TYPES_TOKENS = {
  [HOSTED_PAGE_TYPES.checkout]: 'token',
  [HOSTED_PAGE_TYPES.beneficiaryTokenization]: 'beneficiary_token',
  [HOSTED_PAGE_TYPES.cardTokenization]: 'card_token',
  [HOSTED_PAGE_TYPES.cardIssuing]: 'hp_issued',
  [HOSTED_PAGE_TYPES.idv]: 'idv_token',
  [HOSTED_PAGE_TYPES.subscription]: 'subscription_token',
  [HOSTED_PAGE_TYPES.cardIssuingActivate]: 'hp_issuing_act',
  [HOSTED_PAGE_TYPES.cardIssuingResetPIN]: 'hp_issuing_pin',
  [HOSTED_PAGE_TYPES.cardIssuingSetKba]: 'hp_issuing_kba',
  [HOSTED_PAGE_TYPES.otp]: 'otp_token',
  [HOSTED_PAGE_TYPES.reusable_link]: 'hp_reuse',
  [HOSTED_PAGE_TYPES.customerTokenization]: 'hp_cus',
  [HOSTED_PAGE_TYPES.payoutTracker]: 'hp_payout'
};

export const PAYMENT_METHOD_TYPE = {
  CARD: 'card',
  BANK: 'bank',
  CASH: 'cash',
  EWALLET: 'ewallet'
};

export const CTA_BUTTON_LEGACY_TEXT = {
  place_your_order: 'checkout.place_your_order',
  save: 'beneficiary_save_button'
};

export const PAYMENT_NEXT_ACTIONS = {
  ThreeDSVerification: '3d_verification',
  PendingCapture: 'pending_capture',
  PendingConfirmation: 'pending_confirmation',
  NotApplicable: 'not_applicable'
};

export const BULLET_UNICODE_CHAR = '\u2022';

export const RAPYD_HOSTNAMES = ['checkout.rapyd.net', 'hosted.rapyd.net'];

export const HOSTED_PAGE_MODES = {
  preview: 'preview'
};

export const PAYMENT_CATEGORIES = {
  card: 'card',
  bank_redirect: 'bank_redirect',
  bank: 'bank'
};

export const PAYOUT_CATEGORIES = {
  card: 'card',
  bank_redirect: 'bank_redirect',
  bank: 'bank',
  ewallet: 'ewallet'
};

export const REQUIRED_FIELDS = {
  FIELDS: 'fields',
  PAYMENT_OPTIONS: 'payment_options',
  PAYMENT_METHOD_OPTIONS: 'payment_method_options',
  CUSTOMER: 'customer'
};

export const ERROR_500_MESSAGES = {
  PAGE_EXPIRED: 'ERROR_HOSTED_PAGE_PAGE_EXPIRED',
  PAGE_DECLINED: 'ERROR_PAGE_STATUS_IS_DECLINED',
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
  ERROR_HOSTED_PAGE_PIN_NOT_VALID: 'ERROR_HOSTED_PAGE_PIN_NOT_VALID',
  ERROR_HOSTED_PAGE_INVALID_OTP_CODE: 'ERROR_HOSTED_PAGE_INVALID_OTP_CODE',
  ERROR_HOSTED_PAGE_OTP_CODE_EXPIRED: 'ERROR_HOSTED_PAGE_OTP_CODE_EXPIRED',
  ERROR_HOSTED_PAGE_OTP_MAX_ATTEMPTS_REACHED: 'ERROR_HOSTED_PAGE_OTP_MAX_ATTEMPTS_REACHED'
};

export const FOUR_DIGITS_CVV_CARDS_IMAGES = {
  amex: 'amex-credit-card-v2.svg'
};

export const CHECKBOX_TYPES = {
  USE_MAIN_ADDRESS: 'useMainAddress',
  SAVE_FOR_FUTURE: 'saveForFuture'
};

export const PMT_FIELD_NAME = 'pmt';

export const ERROR_PAGE_TYPES = {
  ERROR_500: 'ERROR_500',
  PAGE_EXPIRED: 'PAGE_EXPIRED',
  PAGE_DECLINED: 'PAGE_DECLINED'
};

export const ERROR_404_PROPS = {
  firstTitleKey: 'errorPage404.404',
  secondTitleKey: 'errorPage404.page_not_found',
  textKey: 'errorPage404.not_found',
  imageName: 'error-page-icon-v2.svg',
  ctaButtonTextKey: 'back_to_website'
};

export enum View {
  list = 'list',
  add = 'add'
}

export const REQUIRED_FIELDS_DISPLAY_NAMES = {
  INPUT: 'Input',
  DROPDOWN: 'Dropdown',
  NUMERIC_INPUT: 'NumericInput',
  YES_NO: 'YesNo',
  DATE_PICKER: 'DatePicker',
  DATE: 'Date',
  CARD_NUMBER: 'CardNumber',
  EXPIRATION_DATE_INPUT: 'ExpirationDateInput',
  COUNTRY_DROPDOWN: 'CountryDropdown'
};

export const INFO_ALERT_TIMEOUT = 5000;

export enum FieldTypes {
  Text = 'text',
  Password = 'password'
}
